/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOtherChargeRate.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/other-charge-rate";

export class AutogenModelOtherChargeRate<RowType extends ModelRow> extends Endpoint<RowType, RowOtherChargeRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOtherChargeRate extends ModelRow<RowOtherChargeRateFields> {
	constructor(values?: Partial<RowOtherChargeRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOtherChargeRateFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	calc_method: string;
	charge_id: string;
	company_id: string;
	customer_id: string;
	descr: string;
	driver_id: string;
	est_fuel_surcharge: string;
	id: string;
	invoice_id: string;
	is_taxable: string;
	rate: number;
	rate_id: number;
	sequence: number;
	units: number;
}

